var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"margin-top":"150px"},attrs:{"fluid":""}},[_c('v-row',{},[_c('v-col',{attrs:{"cols":"12"}},[_c('center',[_c('v-img',{attrs:{"src":"img/vazhl_2.png","fluid":""}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }